import { render, staticRenderFns } from "./Auth-layout.vue?vue&type=template&id=663779b0&scoped=true&lang=pug"
import script from "./Auth-layout.vue?vue&type=script&lang=js"
export * from "./Auth-layout.vue?vue&type=script&lang=js"
import style0 from "./Auth-layout.vue?vue&type=style&index=0&id=663779b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663779b0",
  null
  
)

export default component.exports